<template>
  <div class="mt-0 pt-0">
    <v-card class="elevation-2" outlined>
      <v-card-title class="d-flex flex-wrap align-center" style="gap: 12px;">
        <div>
          <div class="text-h6">Contactos registrados</div>
          <div class="text-body-2 text--secondary">Convierte contactos en prospectos en un clic</div>
        </div>
        <v-spacer></v-spacer>
        <v-chip color="deep-orange lighten-4" class="deep-orange--text text--darken-4" small>
          Total: {{ contactos.length }}
        </v-chip>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-row dense class="mb-2">
          <v-col cols="12" sm="3" md="2">
            <v-text-field
              v-model="desde"
              type="date"
              label="Desde"
              dense
              outlined
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="3" md="2">
            <v-text-field
              v-model="hasta"
              type="date"
              label="Hasta"
              dense
              outlined
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="3" md="2">
            <v-text-field
              v-model="search"
              dense
              outlined
              clearable
              prepend-inner-icon="mdi-magnify"
              label="Buscar contacto"
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="3" md="6" class="d-flex justify-end align-center" style="gap: 8px;">
            <v-btn color="deep-orange" text @click="listar">
              <v-icon left>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
            <v-btn color="deep-orange darken-1" class="white--text" @click="registrar_contacto()">
              <v-icon left>mdi-account-plus</v-icon>
              Registrar
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          :headers="xheaders"
          :items="filteredContactos"
          :loading="loading"
          :items-per-page="55"
          dense
          class="elevation-1"
          no-data-text="No hay contactos para mostrar"
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table" />
          </template>
          <template v-slot:[`item.nombre_completo`]="{ item }">
            <span> {{ item.nombres }} {{ item.apellidos }} </span>
          </template>
          <template v-slot:[`item.opt`]="{ item }">
            <v-btn small color="green" outlined @click="registrar_prospecto(item)">
              <v-icon left small>mdi-briefcase-account</v-icon>
              Prospecto
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <new_contacto ref="refnew_contacto" v-on:onsuccess="listar" />
    <new_prospecto ref="refnew_prospecto" />
  </div>
</template>

<script>
  import new_contacto from './new_contacto.vue';
  import new_prospecto from './new_prospecto.vue';
  import { headers, getContactos } from './utils';

  export default {
    components: {
      new_contacto,
      new_prospecto,
    },
    data() {
      return {
        loading: false,
        xheaders: headers(),
        contactos: [],
        search: '',
        // desde: (() => { const d = new Date(); d.setDate(d.getDate() - 15); return d.toISOString().slice(0, 10); })(),
        desde: (() => { const d = new Date(); d.setDate(1); return d.toISOString().slice(0, 10); })(),
        hasta: (() => { const d = new Date(); d.setDate(d.getDate() + 1); return d.toISOString().slice(0, 10); })(),
      };
    },
    computed: {
      filteredContactos() {
        if(!this.search) return this.contactos;
        const q = this.search.toLowerCase();
        return this.contactos.filter(c =>
          Object.values(c).some(v => String(v).toLowerCase().includes(q))
        );
      }
    },
    methods: {
      async listar() {
        this.loading = true;
        const q = {
          asesor_id: this.$store.state.DATA_USER.id
        }
        if(this.desde) q.desde = this.desde+'T00:00:00Z';
        if(this.hasta) q.hasta = this.hasta+'T23:59:00Z';
        const res = await getContactos(q);
        this.loading = false;

        if(res){
          this.contactos = res;
          // this.$root.$notify.show('registrado :)', { color: 'green', x: 'right' });
        }else if(res && res.error){
          this.$root.$notify.show(res.error, { color: 'red', x: 'right' });
        }else{
          this.$root.$notify.show('algo salio mal :)', { color: 'red', x: 'right' });
        }
        
      },
      registrar_contacto() {
        this.$refs.refnew_contacto.openmodal();
      },
      registrar_prospecto(row) {
        this.$refs.refnew_prospecto.openmodal(row);
      },
    },
    mounted() {
      this.listar();
    },
  };
</script>
